module.exports = __webpack_public_path__ + "img/banner.c132f633.jpeg";